import { MBAnalytics } from '@shared/util/analytics';

export class CollectionViewAnalytics {
  constructor(
    private readonly workflowTemplateId: string,
    private readonly viewTemplateId: string,
  ) {}

  public trackButtonClick(entityId: string): void {
    MBAnalytics.track('CollectionView::ActionButton::Click', {
      workflowTemplateId: this.workflowTemplateId,
      viewTemplateId: this.viewTemplateId,
      entityId,
    });
  }
}
